
if (window.location.hash.includes('#r=')) {
    document.querySelector(".quiz-modal-backdrop").classList.remove("quiz-modal-hide");
}

document.addEventListener("click", function(e) {
    const quizModal = document.querySelector(".quiz-modal-backdrop");
    const quizModalDataset = e.target.dataset.quizModal;
    const isQuizModalButton = e.target.hash == '#quiz-modal-open' || e.target.href == '#quiz-modal-open' || e.target.closest('a[href="#quiz-modal-open"]');

    if (quizModalDataset === "toggle" || isQuizModalButton) {
        e.preventDefault();
        quizModal.classList.remove("quiz-modal-hide")
    } else if (quizModalDataset === "backdrop" || quizModalDataset === "close") {
        quizModal.classList.add("quiz-modal-hide")
    };
})
